import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { getToken } from "../../utils/getToken";

export const useGetSingleCustomerQuery = (id: string) => {
  const token = getToken();

  return useQuery({
    queryKey: ["useGetCustomerQuery", { id }],
    queryFn: () =>
      axiosInstance
        .get(`/customers/${id}`, {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        })
        .then((res) => res.data),

    // onError: (error: any) => {
    //   message.error(
    //     error?.response?.data?.message ||
    //       'An error occurred while fetching customer data.'
    //   );
    // },
    enabled: !!token,
  });
};
